module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": _vm.modalTitle,
      "size": "md",
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.closeCurrentModal()
      }
    }
  }, [_c('header', {
    staticClass: "px-6"
  }, [_c('div', {
    staticClass: "flex space-x-3 items-center mb-4 mt-3"
  }, [_c('span', [_vm._v("\n        After adding a new feedback template you can use on all students or import later to another course, will not be change the old templates.  \n      ")])])]), _vm._v(" "), _c('body', {
    staticClass: "w-full flex-grow overflow-y-auto h-80 mb-4 center items-center px-6 relative"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.template),
      expression: "template"
    }],
    ref: "template-area",
    staticClass: "bg-gray-100 rounded outline-none w-full px-4 py-3 h-full border border-solid border-gray-200 focus:border-gray-300",
    attrs: {
      "placeholder": "Write a new feedback template..."
    },
    domProps: {
      "value": (_vm.template)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.template = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('footer', {
    staticClass: "px-6 mb-5"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('button', {
    staticClass: "bg-gray-100 border hover:border-gray-300 border-solid border-gray-200 text-sm text-gray-600 rounded px-6 py-2",
    on: {
      "click": function($event) {
        return _vm.closeCurrentModal()
      }
    }
  }, [_vm._v("\n        Cancel\n      ")]), _vm._v(" "), _c('button', {
    class: _vm.isTemplateFilled,
    on: {
      "click": function($event) {
        _vm.editingFeedback === false ? _vm.handleCreateFeedback() : _vm.handleEditFeedback()
      }
    }
  }, [_c('div', {
    staticClass: "flex justify-center space-x-2"
  }, [(_vm.editingFeedback === false) ? _c('span', [_vm._v(_vm._s(_vm.isCreating === true ? 'Creating' : 'Create'))]) : _vm._e(), _vm._v(" "), (_vm.editingFeedback === true) ? _c('span', [_vm._v(_vm._s(_vm.isEditing === true ? 'Saving' : 'Save'))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCreating || _vm.isEditing),
      expression: "isCreating || isEditing"
    }],
    staticClass: "loader"
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-255cf894!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/NewFeedbackModal.vue
// module id = 1117
// module chunks = 61